import { fetcher } from '../utils'
import { AppReviewVO } from '@repo/types'

export default async (data: AppReviewVO): Promise<void> => fetcher(`/api/appreview`, 'POST', data)
